<template>
	<div style="box-shadow: 0px 0px 10px 0px rgba(92, 92, 92, 0.1);">
		<div class="container">

      <div class="logo">
        <router-link :to="{path:'/home'}" >
          <!-- <img src="../../public/img/NOLOGO.png" alt=""> -->
          <div style="font-weight:900;font-size:24px">经纬招标</div> 
        </router-link>
      </div>

      <div class="navigation">
        
        <div class="search" v-if="$route.meta.hideSearch != true">
          <input @keyup.enter="searchPosts()" type="text" v-model="search">
          <svg t="1669918257736" style="margin:0px 0px 0px 10px" @click="searchPosts()" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1369" width="20" height="20"><path fill="#0058a4" d="M999.073 878.496L754.049 633.328c-2.856-2.856-6.056-5.032-9.032-7.312a402.928 402.928 0 0 0 65.488-220.72C810.617 181.512 629.249 0 405.361 0 181.481 0 0.001 181.504 0.001 405.304c0 223.912 181.48 405.304 405.248 405.304 81.488 0 157.144-24.24 220.8-65.608 2.288 3.08 4.456 6.168 7.2 8.912l245.024 245.056a85.064 85.064 0 0 0 60.344 25.032c21.824 0 43.656-8.344 60.344-24.92 33.368-33.256 33.368-87.32 0.112-120.584M405.369 682.704C252.457 682.704 128.001 558.24 128.001 405.304c0-152.816 124.456-277.288 277.36-277.288 152.92 0 277.256 124.472 277.256 277.4 0 152.816-124.456 277.288-277.248 277.288" p-id="1370"></path></svg> 
        </div>
          
        <div class="selector">
          <div class="main">
            <router-link :to="{path:'/home'}" >
              首页
            </router-link>
          </div>
        </div>

        <div class="selector">
          <div class="main" @click="select('公告中心','')">
            <div>公告中心</div>
            <!-- <svg style="margin-left:12px;padding-top:3px" t="1670857328387" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3973" width="15" height="15"><path d="M857.088 224.256q28.672-28.672 69.12-28.672t69.12 28.672q29.696 28.672 29.696 68.608t-29.696 68.608l-382.976 380.928q-12.288 14.336-30.72 19.968t-38.912 4.608-40.448-8.704-34.304-22.016l-376.832-374.784q-29.696-28.672-29.696-68.608t29.696-68.608q14.336-14.336 32.256-21.504t36.864-7.168 37.376 7.168 32.768 21.504l313.344 309.248z" p-id="3974" fill="#2b2b2b2b2b2b"></path></svg> -->
          </div>

          <div class="option">
            <div  @click="select('公告中心','招标公告')">招标公告</div>
            <div  @click="select('公告中心','结果公告')">结果公告</div>
            <div  @click="select('公告中心','预中标公告')">预中标公告</div>
            <div  @click="select('公告中心','更正公告')">更正公告</div>
            <div  @click="select('公告中心','需求调查')">需求调查</div>
            <div  @click="select('公告中心','公司通知')">公司通知</div>
          </div>

        </div>

        <div class="selector">
          <div class="main" @click="select('政策法规','')">
            <div>政策法规</div>
            <!-- <svg style="margin-left:12px;padding-top:3px" t="1670857328387" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3973" width="15" height="15"><path d="M857.088 224.256q28.672-28.672 69.12-28.672t69.12 28.672q29.696 28.672 29.696 68.608t-29.696 68.608l-382.976 380.928q-12.288 14.336-30.72 19.968t-38.912 4.608-40.448-8.704-34.304-22.016l-376.832-374.784q-29.696-28.672-29.696-68.608t29.696-68.608q14.336-14.336 32.256-21.504t36.864-7.168 37.376 7.168 32.768 21.504l313.344 309.248z" p-id="3974" fill="#2b2b2b2b2b2b"></path></svg> -->
  
          </div>

        </div>

        <!-- <div class="selector">
          <div class="main" @click="select('main','世界史')">
            <div>下载中心</div>
          </div>
        </div> -->

        <div class="selector">
          <div class="main">
            <router-link :to="{path:'/download'}" >
              下载中心
            </router-link>
          </div>
        </div>

        <div class="selector">
          <div class="main">
            <router-link :to="{path:'/about'}" >
              公司简介
            </router-link>
          </div>
        </div>
        <!-- <div class="selector">
          <div class="main" @click="select('main','世界文献学')">公司简介</div>
        </div> -->

      </div>

		</div>
    
	</div>
</template>

<script>
import axios from "axios";

export default {
  name: "Header",
  data(){
    return{
      headerList:[],
      search:"",
    }
  },
  mounted(){

  },
  methods: {
    select(categoryName,albumName){
      this.$router.push({
        path: '/theme',
        query: { 
          categoryName:categoryName,
          albumName: albumName,
        }
      })
    },
    searchPosts(){
      if(this.search != ""){
        var search = this.search
        this.search = ""
        this.$router.push({
          path: '/search',
          query: { 
            search: search
          }
        })
      }
    }
  },
};
</script>

<style scoped>
.container {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content:space-between;
  min-width: 1300px;
  max-width:1920px;
  margin:0px auto;
}

.logo {
  display: flex;
  align-items: center;
  margin-left: 190px;
}
.logo img{
  height: 22px;
}

.search{
  display: flex;
  align-items: center;
  /* padding: 5px 0px 0px 0px; */
  background-color: #f1f1f1;
  border: #e9e9e9 solid 0.8px;
  padding: 7px 15px 7px 20px;
  border-radius: 15px;
  /* box-shadow: 0px 0px 10px 0px rgba(92, 92, 92, 0.1); */
  margin-right: 10px;
}
.search input{
  border: 0;
  outline: 0;
  width: 190px;
  font-size: 16px;
  color: #7f7f7f;
    background-color: #f1f1f1;

}

a{
  line-height: 0px;
  text-decoration: none;
  color: #0058a4;
}

.navigation{
  display:flex;
  align-items: center;
  margin-right: 180px;
}
.selector{
  position: relative;
  /* cursor: pointer; */
}
.main{
  padding: 28px 15px 28px 15px;
  color: #0058a4;
  font-size: 17px;
  font-weight: 400;
  white-space:nowrap;
  display: flex;
  align-items: center;
}
.main div{
  cursor: pointer;
}
.option{
  border-radius: 10px;
  overflow: hidden;
  position:absolute;
  background-color: #fff;
  color: #0058a4;
  font-size: 16px;
  font-weight: 400;
  top: 80px;
  z-index: 1;
  min-width: 160px;
  display:none;
  border:1px;
  box-shadow: 0px 5px 10px 0px rgba(92, 92, 92, 0.1);
    cursor: pointer;
}
.option div{
  padding: 15px 20px 15px 20px;
  white-space:nowrap
}
.option div:hover{
  background-color: #efefef;
  color: #0058a4;
}
.selector:hover .option{
  display: block;
}
</style>